// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.lee-options li {\n    list-style: none;\n    padding: 0 20px;\n    height: 34px;\n    line-height: 34px;\n    font-size: 14px;\n    cursor: pointer;display: flex;justify-content: space-between;\n}\n.lee-options li span:last-child{color: #999}\n.lee-options li:hover {\n    background: #eee;\n}\n.lee-options li.selected span {\n    color: #46bd87\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
